export default __webpack_public_path__ + "static/media/icons_preference.0edf06f4.svg";